export const dashboardLearnMoreVideoLink = 'https://www.youtube.com/embed/CMEcL4qObw4';
